export default {
	add_new_product: "Adicionar novo produto",
	brand: "Marca",
	detail_sold_products: "Detalhes dos produtos vendidos",
	for_more_than_one_product_click_on_the_add_new_product_button_and_fill_in_each_one: "Para informar mais de um produto, clique no botão \"Adicionar novo produto\".",
	insert_more_sales: "Inserir mais vendas",
	insert_new_sale: "Inserir nova venda",
	insert_sale: "Inserir Venda",
	invoice_number: "Número da Nota Fiscal",
	no_retailers_found: "Nenhum varejista encontrado",
	no_stores_found: "Nenhuma loja encontrada",
	observation: "Observação",
	processor: "Processador",
	product_type: "Tipo de Produto",
	products: "Produtos",
	quantity_points: "Quantidade de Pontos",
	quantity: "Quantidade",
	remove_product: "Remover Produto",
	retailer: "Varejista",
	sale_date: "Data da Venda",
	send_invoices_to_claim_your_points: "Envie Notas Fiscais para reivindicar seus pontos",
	sku: "SKU",
	specify_below_the_product_sold_eligible_that_appears_on_the_invoice_sent: "Especifique abaixo o produto que consta na Nota Fiscal.",
	store: "Loja",
	take_a_picture: "Tirar uma Foto",
	the_note_number_has_already_been_sent_by_the_user_before: "O número da nota já foi enviada pelo usuário anteriormente",
	tip: "Dica",
	upload_invoice: "Enviar Nota Fiscal",
	your_sale_has_been_successfully_registered_and_your_points_were_credited_this_points_are_liable_to_be_auditable_before_your_prize_redeem_is_confirmed: "Sua venda foi registrada com sucesso e seus pontos foram creditados. Esses pontos são passíveis de auditoria antes que o resgate do seu prêmio seja confirmado."
}